import  Supplier from './supplier';
export default Supplier;